// @flow

import React from "react";
import { localize } from "redux-i18n";
import { ColumnsContainer } from "@components";
import type { Rows } from "@components/columns-container/types";
import type { DynamicQuestionContent } from "@modules/service/reducer/dynamic-questions/types";
import { toTitleCase } from "@transformers/response";

type Props = $Exact<{
  data: DynamicQuestionContent,
  ...PropsFromLocalize,
}>;

export class DynamicQuestionLengthScopeView extends React.Component<Props> {
  get data(): Array<Rows> {
    return [
      {
        columns: [
          {
            data: [[this.props.t("DAY_TYPE"), toTitleCase(this.props.data.dayType)]],
          },
          {
            data: [[this.props.t("DURATION_DAYS"), this.props.data.durationDays]],
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer rows={this.data} />;
  }
}

export default localize()(DynamicQuestionLengthScopeView);
